"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToRef = void 0;
// scroll to a ref if it exist after a timeout
const scrollToRef = (ref, smooth, delay) => {
    const scrollFn = () => {
        const currentRef = ref.current;
        if (currentRef) {
            currentRef.scrollIntoView({
                behavior: smooth ? 'smooth' : undefined,
                block: 'nearest',
                inline: 'center'
            });
        }
    };
    if (delay !== undefined) {
        setTimeout(scrollFn, delay);
    }
    else {
        scrollFn();
    }
};
exports.scrollToRef = scrollToRef;
//# sourceMappingURL=scroll.js.map